import { useSelector } from "react-redux";
import Asset1 from "../../../assets/images/asset1.png";
import Asset2 from "../../../assets/images/asset2.png";
import Asset3 from "../../../assets/images/asset3.png";
import { events } from "../../../hooks/config";
import useGAEventTracker from "../../../hooks/useGAEventTracker";
import TrackingFormTab from "./TrackingFormTab";
import TrackingResult from "./TrackingResult";

const ThemeSpecial = ({ order, shop }) => {
  const { category, action, labels } = events.marketing;
  const GAEventsTracker = useGAEventTracker(category);
  const { errorMessage } = useSelector((state) => state.ui);
  const assets = useSelector((state) => state?.assets);
  const configAssets = { asset1: Asset1, asset2: Asset2, asset3: Asset3 };
  const {
    customMessage: { replaceMessage },
  } = useSelector((state) => state.settings);
  const { tracking_form: i18n } = useSelector((state) => state.i18n);
  const dataAssets = typeof assets === "string" ? JSON.parse(assets) : assets;

  const renderAsset = (index) => {
    const path = dataAssets[index]?.path;
    const baseUrl = dataAssets[index]?.baseUrl;
    return path ? baseUrl + path + `?v=${Date.now()}` : configAssets[index];
  };

  return (
    <>
      <div className="omg">
        {!order ? (
          <div className="container-fluid omg-tracking-contain">
            <div className="rows header-page">
              <div className="col">
                <h1 className="h1 title-page">{i18n.title}</h1>
              </div>
            </div>
            <div className="row form-tracking gx-5">
              <div
                className="col-sm-12 col-md-6"
                style={{ marginBottom: "20px" }}
              >
                <TrackingFormTab order={order} shop={shop} />
              </div>
              <div
                className="col-sm-12 col-md-6 col-lg-6"
                style={{ height: "540px" }}
              >
                <div className="row asset-template" style={{ height: "100%" }}>
                  <div className="col-sm-6 col-6">
                    <a
                      href={dataAssets ? dataAssets["asset1"]?.url : ""}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <div
                        className="img-fluid asset-1"
                        onClick={() => {
                          if (assets && assets["asset1"]?.url) {
                            GAEventsTracker(action, labels["asset1"]);
                          }
                        }}
                        style={{
                          backgroundImage:
                            typeof dataAssets["asset1"].src !== "object" &&
                            `url(${renderAsset("asset1")})`,
                          height: "49%",
                          marginBottom: "4%",
                        }}
                      />
                    </a>
                    <a
                      href={dataAssets ? dataAssets["asset2"]?.url : ""}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <div
                        className="img-fluid asset-2"
                        onClick={() => {
                          if (assets && assets["asset2"]?.url) {
                            GAEventsTracker(action, labels["asset2"]);
                          }
                        }}
                        style={{
                          backgroundImage:
                            typeof dataAssets["asset2"].src !== "object" &&
                            `url(${renderAsset("asset2")})`,
                          height: "49%",
                        }}
                      />
                    </a>
                  </div>
                  <div className="col-sm-6 col-6">
                    <a
                      href={dataAssets ? dataAssets["asset3"]?.url : ""}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <div
                        className="img-fluid asset-3"
                        onClick={() => {
                          if (assets && assets["asset3"]?.url) {
                            GAEventsTracker(action, labels["asset3"]);
                          }
                        }}
                        style={{
                          backgroundImage:
                            typeof dataAssets["asset3"].src !== "object" &&
                            `url(${renderAsset("asset3")})`,
                          height: "100%",
                        }}
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <h3 className="omg-error mt-5">{errorMessage}</h3>
            {errorMessage && (
              <div className="omg-custom-message">
                <p className="omg-custom-message-replace mb-5 text-center">
                  {replaceMessage}
                </p>
              </div>
            )}
          </div>
        ) : (
          <>
            <TrackingResult order={order} assets={dataAssets} />
            {/* <div className="omg-special-display-review">
              {reviewSettings &&
                reviewSettings?.isActive &&
                reviewSettings?.show?.length !== 0 && (
                  <DisplayReview setting={reviewSettings} />
                )}
            </div> */}
          </>
        )}
      </div>
    </>
  );
};

export default ThemeSpecial;
